var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7416 7.75877L8.17736 14.3231C7.37318 15.1272 6.28249 15.579 5.14521 15.579C4.00794 15.579 2.91725 15.1272 2.11307 14.3231C1.3089 13.5189 0.857117 12.4282 0.857117 11.2909C0.857117 10.1536 1.3089 9.06294 2.11307 8.25877L8.67736 1.69448C9.21347 1.15836 9.9406 0.857178 10.6988 0.857178C11.457 0.857178 12.1841 1.15836 12.7202 1.69448C13.2563 2.2306 13.5575 2.95773 13.5575 3.71591C13.5575 4.47409 13.2563 5.20122 12.7202 5.73734L6.14879 12.3016C5.88073 12.5697 5.51716 12.7203 5.13807 12.7203C4.75898 12.7203 4.39542 12.5697 4.12736 12.3016C3.8593 12.0336 3.70871 11.67 3.70871 11.2909C3.70871 10.9118 3.8593 10.5483 4.12736 10.2802L10.1916 4.22305",
    stroke: "#414B5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.f98f1ab250645200dbbf59529a26b3a8.svg";
export { ForwardRef as ReactComponent };